import React from 'react';
import { compose } from 'recompose';
import { HTMLTrans, withTranslationProvider } from '../../Common/Translations';
import ReminderForm from './ReminderForm';
import { format } from 'date-fns';

class AddReminderForm extends ReminderForm {
  initState() {
    this.state = {
      isRecurring: true,
      reminderDate: '',
      selectedUserReminderType: null,
      selectedUserReminderTypeOption: null,
      title: '',
    };
  }

  getParamsFromState() {
    const params = {
      user_reminder_type_id: this.state.selectedUserReminderType.id,
      title: this.state.title,
      reminder_date: format(this.state.reminderDate, 'YYYY-MM-DD'),
      is_recurring: this.state.isRecurring
    };
    if (this.state.selectedUserReminderTypeOption) {
      params.user_reminder_type_option_id = this.state.selectedUserReminderTypeOption;
    }
    return params;
  }

  changeSelectedType(clickedType) {
    const nextState = {
      selectedUserReminderType: clickedType,
    };
    if (clickedType.code !== 'birthday') {
      nextState.selectedUserReminderTypeOption = null;
    }
    if (clickedType.code !== 'others') {
      nextState.isRecurring = true;
    }
    this.setState(nextState);
  }

  modalHeader() {
    return <div className="modal-header">
      <h3 className="font-weight-bold">
        <HTMLTrans id='account.dasboard_reminder_modal_header_add_new_reminder'>Add New Reminder</HTMLTrans>
      </h3>
      {this.closeButton()}
    </div>
  }

  actionButtons() {
    return <div className="modal-reminder-add-save-row">
      <button
        className="btn btn-primary"
        onClick={this.submitReminder}
        disabled={!this.isValid()}
      >
        <HTMLTrans id='account.dasboard_reminder_modal_save'>Save</HTMLTrans>
      </button>
    </div>
  }
}

const enhance = compose(withTranslationProvider);
export default enhance(AddReminderForm);
export const undecorated = AddReminderForm;


// WEBPACK FOOTER //
// ./src/Account/RemindMe/AddReminderForm.js